import { render, staticRenderFns } from "./FormAdmin.vue?vue&type=template&id=27b64770&scoped=true"
import script from "./FormAdmin.vue?vue&type=script&lang=js"
export * from "./FormAdmin.vue?vue&type=script&lang=js"
import style0 from "./FormAdmin.vue?vue&type=style&index=0&id=27b64770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b64770",
  null
  
)

export default component.exports